// extracted by mini-css-extract-plugin
export var box = "_21-1";
export var checkboxRow = "_21-8";
export var checked = "_21-2";
export var descriptionSpacer = "_21-a";
export var disabled = "_21-3";
export var icon = "_21-6";
export var input = "_21-0";
export var labelSpacer = "_21-9";
export var medium = "_21-5";
export var small = "_21-4";
export var text = "_21-7";